import { alfawinMetrics } from './alfawinMetrics.js';
import { selectedProfitLoss } from './alfawinProfitLoss.js';
import { warehousePendingRows, warehouseTotals } from './warehouseDashboardMetrics.js';

// Mismo criterio del PyG configurable del dashboard, sin sumar las facturas de
// Ennage a su contabilidad. Las empresas se identifican por nombre, no por actividad.
function resultado(data, company) {
  try {
    if (!data) return null;
    if (company !== 'a') {
      if (!Array.isArray(data.accounts)) return null;
      if (data.accounts.some(row => {
        const account = String(row.account || '').trim();
        const amount = row[account[0] === '7' ? 'income' : 'expense'];
        return /^[67]/.test(account) && (amount == null || amount === '');
      })) return null;
    }
    return selectedProfitLoss(data, company).result;
  } catch {
    // Una asignación inválida no debe exponer el mensaje ni producir un cero.
    return null;
  }
}

export function adaptarDatosInforme({ datos2025, datos2026, fechaCorte, pedidosPendientes }) {
  const periodo = (anio, data, to) => {
    const filters = { from: `${anio}-01-01`, to, company: 'all' };
    const valid = Array.isArray(data?.invoices) && data.invoices.every(row =>
      row.kind !== 'sales' || (['iva', 'a'].includes(row.company) &&
        row.date >= filters.from && row.date <= to && row.net != null &&
        row.net !== '' && Number.isFinite(Number(row.net))));
    const resultadoEnnage = resultado(data, 'iva');
    const resultadoGenaen = resultado(data, 'a');
    return {
      anio, tipo: anio === 2025 ? 'cerrado' : 'acumulado',
      facturacionTotal: valid ? alfawinMetrics(data, filters, fechaCorte).salesNet : null,
      resultadoEnnage, resultadoGenaen,
      resultadoConjunto: resultadoEnnage !== null && resultadoGenaen !== null ? resultado(data, 'all') : null,
      ebitda: null, fondoManiobra: null, deudaFinanciera: null,
    };
  };
  const pendientes = Array.isArray(pedidosPendientes) ? warehousePendingRows(pedidosPendientes) : null;
  const importeFirmado = pendientes && pendientes.every(row => Number.isFinite(row.amount))
    ? warehouseTotals(pendientes, []).pendingAmount : null;
  return {
    empresa: { nombre: 'Nuevo Alfatex · Ennage y Genaen', fechaCorte },
    periodos: [periodo(2025, datos2025, '2025-12-31'), periodo(2026, datos2026, fechaCorte)],
    pedidos: {
      importeFirmado, costeProduccionPrevisto: null, margenBrutoPrevisto: null,
      anticiposClientes: null, necesidadPicoTesoreria: null,
      financiacionSolicitada: null, plazoMeses: null,
    },
    observaciones: [
      '2025: periodo anual consultado; cierre contable pendiente de validar. 2026: acumulado hasta la fecha de corte indicada.',
      'Facturación: suma de bases netas de facturas de Ennage y Genaen, sin añadir ingresos contables.',
      'Ennage: resultado contable de cuentas 6 y 7, excluidos asientos de apertura, regularización y cierre. Genaen: resultado de gestión obtenido de ventas menos compras y gastos, sin IVA, con asignación a cuentas de gasto; no dispone de diario contable.',
      'Resultado conjunto de gestión: resultado contable de Ennage más resultado de gestión de Genaen, según el mismo criterio del PyG del dashboard. Los gastos comunes registrados en Ennage se incluyen una sola vez. No se añaden las facturas de Ennage de nuevo ni se presenta como cierre contable consolidado.',
      'Cartera firmada: pedidos captados por representantes y firmados por clientes, según el criterio confirmado por la empresa. Se valora exclusivamente la cantidad pendiente de servir, excluyendo pedidos cancelados y cantidades ya servidas; una línea sin precio impide valorar la cartera completa.',
      'El coste de todas las órdenes de fabricación tiene un alcance distinto de la cartera pendiente y no se cruza con ella para estimar margen.',
      'Tesorería pendiente de un calendario completo de cobros y pagos. La marca de sincronización no acredita el cierre del periodo.',
    ],
  };
}

// El cliente se recibe del dashboard. No hay endpoints ni permisos adicionales.
export async function cargarDatosInforme(client, hoy, pedidosPendientes) {
  const fechaCorte = hoy < '2026-12-31' ? hoy : '2026-12-31';
  const read = async (from, to) => {
    try {
      const { data, error } = await client.rpc('erp_financial_dashboard', {
        p_from: from, p_to: to, p_company: 'all',
      });
      return error ? null : data;
    } catch {
      return null;
    }
  };
  const [datos2025, datos2026] = await Promise.all([
    read('2025-01-01', '2025-12-31'), read('2026-01-01', fechaCorte),
  ]);
  return adaptarDatosInforme({ datos2025, datos2026, fechaCorte, pedidosPendientes });
}
